module.exports = __webpack_public_path__ + "media/images/MICROBIUM-e52a73922324ab7cf8d9f92e8b64a720.svg";